module.exports = __webpack_public_path__ + "static/media/desktop-modal-br.5dce178c.png";